import React, { useState, useEffect } from "react";

import "quill/dist/quill.snow.css";

import BtnPdf from "../../Commons/Buttons/BtnPdf";
import SelectField from "../../Commons/Forms/SelectField";
import TableSpinner from "../../TableSpinner/TableSpinner";

import { useQuill } from "react-quilljs";
import {
  formatDateMMMMDYYYY,
  formatDateWithSuffix,
} from "../../Helpers/Utilities/Common";
import { formatDate } from "../../../Assets/Helpers/Common";
import { useParams } from "react-router-dom";
import { getMedicalCertificate } from "../../Helpers/API/PatientApi/FormApi";
import { FORM } from "../../../Constants/doctor";
import {
  getResidentDetails,
  getRole,
  getUser,
} from "../../Helpers/Utilities/Common";
import { getVitalSigns } from "../../Helpers/API/VitalSignsApi/VitalSignsApi";

function MedicalCertificateForm({ fileName }) {
  const { id } = useParams();
  const role = getRole();
  const user = getUser();
  const details = getResidentDetails(user);
  const currentDate = new Date();
  const [formDetails, setFormDetails] = useState({});
  const [formPdf, setFormPdf] = useState(null);
  const [type, setType] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { quill, quillRef } = useQuill();
  const [latestVitalSigns, setLatestVitalSigns] = useState([]);
  const [typeValue, setTypeValue] = useState({
    value: 1,
    label: "Medical Certificate for Absences",
  });
  const [selectedDoctor, setSelectedDoctor] = useState({
    //default value
    value: "1",
    label: "MYT ADMIN",
    prc_no: "PTR No. 111111",
    // license_no: 'Lic. No. 79031',
  });

  //formats for formTypes
  const types = {
    1: `
      <br/>
      <br/>
      <h2 style="text-align:center;">
        <strong><u>MEDICAL CERTIFICATE</u></strong>
      </h2>
      <br/>
      <br/>
      <br/>
      <p><strong>TO WHOM IT MAY CONCERN:</strong></p>
      <br/>
      <p>This is to certify that <strong>${
        formDetails?.patient && formDetails.patient[0]?.last_name.toUpperCase()
      }, ${
      formDetails?.patient && formDetails.patient[0]?.first_name?.toUpperCase()
    } ${
      formDetails?.patient &&
      formDetails.patient[0]?.middle_initial?.toUpperCase()
    } ${
      formDetails?.patient && formDetails.patient[0]?.suffix?.toUpperCase()
    }, ${
      formDetails?.patient && formDetails.patient[0]?.age
        ? `${formDetails.patient[0].age.replace(/y\/o/i, "").trim()}`
        : ""
    }, ${formDetails?.patient && formDetails.patient[0]?.sex?.toUpperCase()}, ${
      formDetails?.patient && formDetails.patient[0]?.status?.toUpperCase()
    }</strong> and a resident of <strong> ${
      formDetails?.patient && formDetails.patient[0]?.address?.toUpperCase()
    }</strong>, was seen and examined as Outpatient at ClinicaPrime from
      <strong>${formatDateMMMMDYYYY(
        currentDate
      ).toUpperCase()}</strong> due to the following</p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>DIAGNOSIS/ES:</strong></p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>${generateDiagnosisBullets(
        formDetails?.diagnosis
      )}</strong></p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>PROCEDURE:</strong></p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>REMARKS:</strong></p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Issued this 
        ${formatDateWithSuffix(currentDate)} at Ormoc City, Leyte Philippines 
        upon the request of the above-mentioned person/interested party for whatever purpose this will 
        serve him/her best.</strong></p>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <p style="text-align:left; font-size:18px">
        <strong><u>${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.doctor_name || ""
            : role === "nurse"
            ? selectedDoctor?.label || ""
            : details?.[0]?.name || ""
        }
        </u></strong>
      </p>
      <p style="text-align:left;">
        ${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.ptr || ""
            : role === "nurse"
            ? selectedDoctor?.prc_no || ""
            : details?.[0]?.prc_no || ""
        }
      </p>
    `,
    2: `
      <br/>
      <br/>
      <h2 style="text-align:center;">
        <strong><u>MEDICAL CERTIFICATE</u></strong>
      </h2>
      <br/>
      <br/>
      <br/>
      <p><strong>TO WHOM IT MAY CONCERN:</strong></p>
      <br/>
      <p>This is to certify that <strong>${
        formDetails?.patient && formDetails.patient[0]?.last_name.toUpperCase()
      }, ${
      formDetails?.patient && formDetails.patient[0]?.first_name?.toUpperCase()
    } ${
      formDetails?.patient &&
      formDetails.patient[0]?.middle_initial?.toUpperCase()
    }, ${
      formDetails?.patient && formDetails.patient[0]?.age
        ? `${formDetails.patient[0].age.replace(/y\/o/i, "").trim()}`
        : ""
    }, ${formDetails?.patient && formDetails.patient[0]?.sex?.toUpperCase()}, ${
      formDetails?.patient && formDetails.patient[0]?.status?.toUpperCase()
    }</strong> and a resident of <strong> ${
      formDetails?.patient && formDetails.patient[0]?.address?.toUpperCase()
    }</strong>, was seen and examined as Outpatient at ClinicaPrime from
      <strong>${formatDateMMMMDYYYY(
        currentDate
      ).toUpperCase()}</strong> due to the following</p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>DIAGNOSIS/ES:</strong></p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>${generateDiagnosisBullets(
        formDetails?.diagnosis
      )}</strong></p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>PROCEDURE:</strong></p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>REMARKS:</strong></p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Issued this 
        ${formatDateWithSuffix(currentDate)} at Ormoc City, Leyte Philippines 
        upon the request of the above-mentioned person/interested party for whatever purpose this will 
        serve him/her best.</strong></p>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <p style="text-align:left; font-size:18px">
        <strong><u>${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.doctor_name || ""
            : role === "nurse"
            ? selectedDoctor?.label || ""
            : details?.[0]?.name || ""
        }
        </u></strong>
      </p>
      <p style="text-align:left;">
        ${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.ptr || ""
            : role === "nurse"
            ? selectedDoctor?.prc_no || ""
            : details?.[0]?.prc_no || ""
        }
      </p>
    `,
    3: `
      <br/>
      <br/>
      <h2 style="text-align:center;">
        <strong><u>MEDICAL CERTIFICATE</u></strong>
      </h2>
      <br/>
      <br/>
      <br/>
      <p><strong>TO WHOM IT MAY CONCERN:</strong></p>
      <br/>
      <p>This is to certify that <strong>${
        formDetails?.patient && formDetails.patient[0]?.last_name.toUpperCase()
      }, ${
      formDetails?.patient && formDetails.patient[0]?.first_name?.toUpperCase()
    } ${
      formDetails?.patient &&
      formDetails.patient[0]?.middle_initial?.toUpperCase()
    }, ${
      formDetails?.patient && formDetails.patient[0]?.age
        ? `${formDetails.patient[0].age.replace(/y\/o/i, "").trim()}`
        : ""
    },  ${
      formDetails?.patient && formDetails.patient[0]?.sex?.toUpperCase()
    }, ${
      formDetails?.patient && formDetails.patient[0]?.status?.toUpperCase()
    }</strong> and a resident of <strong> ${
      formDetails?.patient && formDetails.patient[0]?.address?.toUpperCase()
    }</strong>, was seen and examined as Outpatient at ClinicaPrime from
      <strong>${formatDateMMMMDYYYY(
        currentDate
      ).toUpperCase()}</strong> due to the following</p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>DIAGNOSIS/ES:</strong></p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>${generateDiagnosisBullets(
        formDetails?.diagnosis
      )}</strong></p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>PROCEDURE:</strong></p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>REMARKS:</strong></p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Issued this 
        ${formatDateWithSuffix(currentDate)} at Ormoc City, Leyte Philippines 
        upon the request of the above-mentioned person/interested party for whatever purpose this will 
        serve him/her best.</strong></p>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <p style="text-align:left; font-size:18px">
        <strong><u>${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.doctor_name || ""
            : role === "nurse"
            ? selectedDoctor?.label || ""
            : details?.[0]?.name || ""
        }
        </u></strong>
      </p>
      <p style="text-align:left;">
        ${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.ptr || ""
            : role === "nurse"
            ? selectedDoctor?.prc_no || ""
            : details?.[0]?.prc_no || ""
        }
      </p>
    `,
    4: `
      <br/>
      <br/>
      <h2 style="text-align:center;">
        <strong><u>HEALTH EXAMINATION RECORD</u></strong>
      </h2>
      <br/>
      <br/>
      <p>Name: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>${
          formDetails?.patient &&
          formDetails.patient[0]?.formatted_patient_name.toUpperCase()
        }</strong>
      </p>
      <p>Age: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>${
          formDetails?.patient && formDetails.patient[0]?.age
            ? `${formDetails.patient[0].age.replace(/y\/o/i, "").trim()}`
            : ""
        } YEARS OLD
        </strong> 
      </p>
      <p>Address: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>${
          formDetails?.patient && formDetails.patient[0]?.address.toUpperCase()
        }</strong>
      </p>
      <p>Sex: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>${
          formDetails?.patient && formDetails.patient[0]?.sex?.toUpperCase()
        }</strong> </p>
      <p>Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>${formatDateMMMMDYYYY(currentDate).toUpperCase()}</strong>
      </p> 
      <p>Civil Status: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
        <strong>${
          formDetails?.patient?.[0]?.status
            ? formDetails.patient[0].status.toUpperCase()
            : ""
        }</strong>
      </p>
      <br/>
      <p>Referred by (Name of Company): <strong>
        ${
          formDetails?.patient?.[0]?.referred_by
            ? formDetails.patient[0].referred_by.toUpperCase()
            : ""
        }</strong>
      </p>
      <br/>
      <p>Weight: <strong>${
        latestVitalSigns?.weight ? latestVitalSigns.weight : ""
      } kg</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Height: <strong>${
          latestVitalSigns?.height_in_ft ? latestVitalSigns.height_in_ft : ""
        }</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        BMI: <strong>${
          latestVitalSigns?.bmi ? latestVitalSigns.bmi : ""
        }</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Hemorrhoid:<strong> N/A</strong>
      </p>
      <p>RR:<strong> ${
        latestVitalSigns?.respiratory_rate
          ? latestVitalSigns.respiratory_rate
          : ""
      } cpm</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        BP:<strong> ${
          latestVitalSigns?.bp ? latestVitalSigns.bp : ""
        } mmHg</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        PR:<strong> ${
          latestVitalSigns?.heart_rate ? latestVitalSigns.heart_rate : ""
        } bpm</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        Hernia:<strong> N/A</strong>
      </p>
      <br/>
      <p>Respiratory System:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Circulatory System:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Digestive System:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Genitourinary System:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Skin:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Locomotor System:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Nervous System:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <br />
      <p>Eyes&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
          Right (OD):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>${
            latestVitalSigns?.right_eye_vision
              ? latestVitalSigns.right_eye_vision
              : ""
          }</strong>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Left (OS):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>${
            latestVitalSigns?.left_eye_vision
              ? latestVitalSigns.left_eye_vision
              : ""
          }</strong>
      </p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Color Perception:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong></p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vision:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Uncorrected
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OD:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OS:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong></
      </p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Corrected
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OD:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OS:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong></
      </p>
      <br />
      <p>Ears</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hearing:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Right (AD):
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Left (AS):
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>NORMAL</strong>
      </p>
      <br/>
      <p>Nose:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Teeth and Gum:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>Chest PA View X-Ray:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>NORMAL</strong></p>
      <p>HBs Antigen Test:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
        <strong>N/A</strong></p>
      <br/>
      <br/>
      <p><strong>REMARKS: </strong></p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>${generateDiagnosisBullets(
        formDetails?.diagnosis
      )}</strong></p>
      <p><strong>RECOMMENDATION:</strong></p>
      <br/>
      <p style="text-align:right; font-size:18px">
        <strong><u>${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.doctor_name || ""
            : role === "nurse"
            ? selectedDoctor?.label || ""
            : details?.[0]?.name || ""
        }
        </u></strong>
      </p>
      <p style="text-align:right;">
        ${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.ptr || ""
            : role === "nurse"
            ? selectedDoctor?.prc_no || ""
            : details?.[0]?.prc_no || ""
        }
      </p>
    `,
  };

  function generateDiagnosisBullets(diagnosisList) {
    if (!Array.isArray(diagnosisList) || diagnosisList.length === 0)
      return "N/A";

    return `
      <ul style="margin: 0; padding-left: 20px;">
        ${diagnosisList.map((d) => `<li>${d?.diagnosis_name}</li>`).join("")}
      </ul>
    `;
  }

  // GET MEDICAL CERTIFICATE FOR FORM CONTENT
  async function fetchForm() {
    setIsLoading(true);
    const res = await getMedicalCertificate({
      patient_id: id,
    });

    if (res.data) {
      let formData = res.data.data;
      let patientData = formData.patient["0"]; // Access patient details at index "0"
      let middleInitial = patientData.middle_name
        ? patientData.middle_name.charAt(0) + "."
        : "";
      let suffix = patientData.suffix ? patientData.suffix : "";

      setFormDetails({
        ...formData,
        patient: {
          ...formData.patient,
          0: {
            ...patientData,
            status: patientData?.status ? patientData?.status : "",
            middle_initial: middleInitial, // Add middle_initial to patient data
            suffix: suffix,
          },
        },
      });
    } else if (res.error) {
    }
    setIsLoading(false);
  }

  async function fetchVitalSigns() {
    const res = await getVitalSigns(id);
    if (res.data && res.data.data.length > 0) {
      // Get the vital sign on the first index, which is latest vital sign
      var latest_vital_sign = res.data.data[0];
      setLatestVitalSigns(latest_vital_sign);
    } else if (res.error) {
      setLatestVitalSigns([]);
    }
  }

  useEffect(() => {
    fetchForm();
    fetchVitalSigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (quill) {
  //     quill.clipboard.dangerouslyPasteHTML(content);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [quill, formDetails, selectedDoctor]);

  useEffect(() => {
    if (quill) {
      var quillContent = types[type];
      quill.clipboard.dangerouslyPasteHTML(quillContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quill, type, formDetails, selectedDoctor]);

  function handleDoctorChange(e) {
    setSelectedDoctor({
      value: e.value,
      label: e.label,
      prc_no: e.prc_no,
      license_no: e.license_no,
    });
  }

  return (
    <div className="">
      <div className="row">
        <div className="col-4" />
        {role !== "nurse" && ( //create space to adjust placement for type dropdown if role is not nurse
          <div className="col-4" />
        )}
        <div className="col-4 med-cert-dropsearch">
          <SelectField
            searchable
            className="dropsearch-filter mt-3"
            name="laboratory"
            size={`sm`}
            // placeholder={"SELECT"}
            value={typeValue}
            options={[
              {
                value: 1,
                label: "Medical Certificate for Absences",
              },
              {
                value: 2,
                label: "Medical Certificate for Extended Absences",
              },
              {
                value: 3,
                label: "Medical Fitness Certificate",
              },
              {
                value: 4,
                label: "Health Examination Record",
              },
            ]}
            onChange={(e) => {
              setType(e.value);
              setTypeValue({ value: e.value, label: e.label });
            }}
          />
        </div>
        {role === "nurse" && (
          <div className="col-4 med-cert-dropsearch">
            <SelectField
              searchable
              className="dropsearch-filter mt-3"
              name="laboratory"
              size={`sm`}
              value={selectedDoctor}
              options={[
                {
                  value: "28",
                  label: "Airon May Estremos",
                  prc_no: "PRC No. 0158271",
                },
                {
                  value: "30",
                  label: "Raul Jr. J. Pales",
                  prc_no: "PRC No. 0158844",
                },
              ]}
              onChange={(e) => {
                handleDoctorChange(e);
              }}
            />
          </div>
        )}
      </div>
      {!isLoading ? (
        <>
          <div className="row p-5 pt-1 ps-3 mt-1 quill-cont mb-5 med-cert-container">
            <div id="med_cert" ref={quillRef} className="custom-quill" />
          </div>
        </>
      ) : (
        <>
          <div className="row p-5 pt-1 ps-3 mt-1 quill-cont mb-5">
            <TableSpinner />
          </div>
        </>
      )}
      <div className="row justify-content-end mt-5 ">
        <div className="col-9"></div>
        <div className="col">
          <BtnPdf
            size={"sm"}
            divId={"med_cert"}
            label={"Save Form"}
            fileName={fileName}
            setFormPdf={setFormPdf}
            quill={quill}
            formPdf={formPdf}
            id={id}
            typeValue={typeValue}
            paperType={"a4"}
          />
        </div>
      </div>
    </div>
  );
}
export default MedicalCertificateForm;
